export enum ProfilePatientTypeEnum {
  AlreadyAPatient = 1,
  NotAPatientYet = 2,
}
